    window.addEventListener("klaviyoForms", function(e) { 
        if(e.detail.type == 'stepSubmit') {
			$('.skip-template-signup').hide();
			$('.template-download-wrapper').show();
		}
		 if (e.detail.type == 'submit') {
			var _learnq = window._learnq || [];
			var product = $('.main-product').data('title');
			console.log(product);
			_learnq.push(['identify', {
				'Product Page' : product
			}]);
		} 
    });


//Unit Prices
$( window ).on( "load", function() {
	var target = $('#main-price')[0];
    var ob = new MutationObserver(function(mutations){
    	var price = Number($('#main-price').text().replace(/[^0-9.-]+/g,""));
        $('.price-inside-button .regular-price').text($('#main-price').text());
     	var unitprice = price / $('input[name="quantity"]').val();
      	$('.unit-price').text('$'+ parseFloat(unitprice).toFixed(2));
    });
    var config = { 
		attributes: true, 
		childList: true, 
		characterData: true 
	};
    ob.observe(target,config);
})
$('.skip-template-signup, .uploadkit-show-upload-after-template').on('click',function(){
	$('.button-close').trigger("click");
	$('.uploadkit-button.uploadkit-button-full-width').trigger("click");
});
$('#uploadkit-show-upload').on('click',function(){
	$('.uploadkit-button.uploadkit-button-full-width').trigger("click");
});

$('.button-close').on('click',function(){
	$('.overlay').removeClass('open');
});
$('.product-form__fake-submit').on('click', function(){
	$(this).find('.button-title').text('Loading...');
	$('button.product-form__submit').click();
})



window.ppDesignerInitialized = function(_class) {
    //Show PP Button
    $('#pp-show-editor').removeClass('loading');
	    //On Click Show Editor
    $('#pp-show-editor').on('click',function(){
		var pass = true;
      	$('.options-list').each(function(){
			var input = $(this).find('input[type="radio"]:checked');
			if(input.length === 0) {
				pass = false;
			}
		});
		if(pass) {
      		$('#pp-inline-editor').show();
        	ppclient.fire('show-app');
		} else {
			alert("Please select all options above first");
		}
  	});
	var currentTemplate = 0;

	function resizeCanvas(){
        var sizeSelector = $('.template-selector input[type="radio"]:checked').siblings('label').find('span').text();
        var width = '';
        var height = '';
        if(sizeSelector == 'INPUT CUSTOM SIZE'){
					console.log('running resize');
			if($('.land-width input').val()){
				width = $('.land-width input').val();
			}else if ($('.port-width input').val()){
				width = $('.port-width input').val();
			}else{
				width = $('.square-size-input input').val();
			}
			if($('.land-height input').val()){
				height = $('.land-height input').val();
			}else if ($('.port-height input').val()){
				height = $('.port-height input').val();
			}else{
				height = $('.square-size-input input').val();
			}
			height = height.toString().replace(/[^\d.-]/g, '');
			width = width.toString().replace(/[^\d.-]/g, '');

			if(height && width){
				console.log('resizing to' + width + 'w ' + height);
				ppclient.fire('resize-page', {
				width: parseInt(width),
				height: parseInt(height),
				pageId: 0,
				scaleItems: true,
				});
			}
    	}
	}
	function checkTemplateID(_val){
      var template = $('.template-selector input[type="radio"]:checked');
      var templateid = $(template).parent().attr('class');
		templateid = templateid.replace('field choice admin__field admin__field-option ','');
      var landscape = '';
      var portrait = '';
      if(templateid){
        if(templateid.includes('l-') || templateid.includes('p-')){
          var ids = templateid.split(" ");
          $.each(ids,function(k,v){
            if(v.includes('l-')){
              landscape = v.replace('l-','');
            }else{
              portrait = v.replace('p-','');
            }
          })
          var orientation = $('.orientation option:selected').text();
          if (orientation.includes('Landscape')){
              templateid = landscape;
          }else if(orientation.includes('Portrait')){
              templateid = portrait;
          }
        }

        if(templateid.includes('custom-input')){
          templateid = templateid.replace('custom-input-','');
        }
		console.log('running template check');
		if(currentTemplate != templateid) {
			currentTemplate = templateid;
        	ppclient.fire('load-design-by-id', templateid);
		}
      }else{
      }
    }
	function openReviewModal(_val) {
		let _data = _val.data;
		if(_data && _data.previews && _data.previews.length) {
			$('.reviewModal__image').html(_data.previews.reduce((_str, _prev) => `${_str}<img src="${_prev}">`, ''));
		}
		var options = [];
			$('.options-list').each(function(){
			var input = $(this).find('input[type="radio"]:checked');
			if(input.length > 0) {
				options.push(input.siblings('label').find('span:first-child').text());
			}
		});
		if(options.length > 0) {
			$('.reviewModal__options span').text(options.join(', '));
		}

		$('.reviewModal__quantity span').text($('.quantity__input ').val());
		var price = Number($('#main-price').text().replace(/[^0-9.-]+/g,""));
      	$('.reviewModal__price').text('$'+ parseFloat(price).toFixed(2));
		$('.reviewModal__unitprice span').text($('.unit-price').text());

		const btn = $('.storeify-show-quote');
		const modal = document.querySelector('#reviewModal');
		modal.show(btn);
		$('.overlay').addClass('open');
	}

	ppclient.on('design-loaded', resizeCanvas);
	ppclient.on('editor-shown', checkTemplateID);
	ppclient.on('project-saved', openReviewModal);
}